import { ofType } from 'redux-observable'

import APP, { epicErrorHandler, epicResponseHandler, epicServerRequest, serverResponse } from 'app'

import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

export const VERIFY_FETCH = 'VERIFY_FETCH'
export const VERIFY_FETCH_ERROR = 'VERIFY_FETCH_ERROR'
export const VERIFY_FETCH_FULFILLED = 'VERIFY_FETCH_FULFILLED'
export const VERIFY_FETCH_CANCELED = 'VERIFY_FETCH_CANCELED'

export const getVerifyInitialState = serverResponse

export const verifyFetch = (code, token) => ({
  payload: { code, token },
  type: VERIFY_FETCH,
})

export const verifyFetchFulfilled = (payload) => ({
  payload,
  type: VERIFY_FETCH_FULFILLED,
})

export const verifyFetchCanceled = () => ({
  payload: null,
  type: VERIFY_FETCH_CANCELED,
})

export const verifyFetchError = (payload) => {
  let msg = ''
  let title = ''
  if (payload.error.code === 401) {
    title = 'Link no válido'
    msg = 'El link de cambio de clave no es válido o ha caducado'
  }

  Object.assign(payload.error, { msg })

  return {
    notification: {
      title,
    },
    payload,
    type: VERIFY_FETCH_ERROR,
  }
}

export const verifyFetchEpic = (action$) =>
  action$.pipe(
    ofType(VERIFY_FETCH),
    mergeMap((action) =>
      epicServerRequest('post', `${APP.api_url}/user/verify`, action, action.payload).pipe(
        map(epicResponseHandler(verifyFetchFulfilled, action)),
        takeUntil(action$.pipe(ofType(VERIFY_FETCH, VERIFY_FETCH_CANCELED))),
        catchError(epicErrorHandler(verifyFetchError, action)),
      ),
    ),
  )
